import type { CalendarService } from "@/types"

export function durationMinutesFromRange(start?: string | null, end?: string | null): number {
  if (!start || !end) return 0
  return Math.max(
    0,
    Math.round((new Date(end).getTime() - new Date(start).getTime()) / 60000),
  )
}

export function selectedCalendarService(args: {
  services: CalendarService[]
  serviceId?: string | null
  fallback?: {
    id?: number | null
    name?: string | null
    emoji?: string | null
    duration_minutes?: number | null
  } | null
}): CalendarService | null {
  const fromList = args.services.find(
    (service) => service.id.toString() === String(args.serviceId || ""),
  )
  if (fromList) return fromList

  const fallback = args.fallback
  if (
    !args.serviceId ||
    !fallback?.id ||
    !fallback.name ||
    String(fallback.id) !== String(args.serviceId)
  ) return null

  return {
    id: fallback.id,
    name: fallback.name,
    duration_minutes: fallback.duration_minutes || 0,
    price_cents: 0,
    color: null,
    emoji: fallback.emoji || null,
  }
}
